import Glide from '@glidejs/glide';

const TestimonialsSlider = () => {
  const slider = new Glide('.testimonials', {
    perView: 3,
    focusAt: 'center',
    type: 'carousel',
    breakpoints: {
      1024: {
        perView: 1,
      },
    },
  });

  const testimonialsNodes = document.querySelectorAll('.testimonials__item');
  const removeActiveClass = () => {
    document
      .querySelector('.testimonials__item.testimonials__item--active')
      .classList.remove('testimonials__item--active');
  };

  slider.on('build.before', () => {
    testimonialsNodes[0].classList.add('testimonials__item--active');
  });

  slider.on('run.before', removeActiveClass);
  slider.on('update', removeActiveClass);

  slider.on('run', () => {
    testimonialsNodes[slider.index].classList.add('testimonials__item--active');
  });

  slider.mount();
};

export default TestimonialsSlider;
